export type RecipientField = "to" | "cc" | "bcc";

export type RecipientsByField = Record<RecipientField, string[]>;

export const RECIPIENT_FIELDS: RecipientField[] = ["to", "cc", "bcc"];

const normalize = (email: string) => email.trim().toLowerCase();

const hasRecipient = (emails: string[], email: string) =>
    emails.some((e) => normalize(e) === normalize(email));

export const getRecipientFields = (
    recipients: RecipientsByField,
    email: string,
): RecipientField[] =>
    RECIPIENT_FIELDS.filter((field) => hasRecipient(recipients[field], email));

export const dedupeRecipients = (
    recipients: RecipientsByField,
): RecipientsByField => {
    const seen = new Set<string>();
    const keepFirst = (emails: string[]) =>
        emails.filter((email) => {
            const key = normalize(email);
            if (seen.has(key)) {
                return false;
            }
            seen.add(key);

            return true;
        });

    return {
        to: keepFirst(recipients.to),
        cc: keepFirst(recipients.cc),
        bcc: keepFirst(recipients.bcc),
    };
};

export const moveRecipient = (
    recipients: RecipientsByField,
    email: string,
    source: RecipientField,
    target: RecipientField,
): RecipientsByField => {
    if (source === target || !recipients[source].includes(email)) {
        return recipients;
    }

    return {
        ...recipients,
        [source]: recipients[source].filter((e) => e !== email),
        [target]: hasRecipient(recipients[target], email)
            ? recipients[target]
            : [...recipients[target], email],
    };
};
